import { createAction } from '@reduxjs/toolkit';
import { ActionNames, Errors } from '_constants'
import { helpCenterService } from '_services';
import { alertActions } from './alert.actions';

export const helpCenterActions = {
    categoryChange: createAction(ActionNames.HELP_CENTER_CATEGORY_CHANGE),

    requestHelp: (msg, toAddress, category, includeIntegration) => dispatch => {
        dispatch(helpCenterActions.requestHelpRequest({ msg, toAddress, category, includeIntegration }));

        helpCenterService.requestHelp(msg, toAddress, category, includeIntegration)
            .then(
                () => {
                    dispatch(helpCenterActions.requestHelpSuccess(msg, toAddress, category, includeIntegration));
                    dispatch(alertActions.successMsg('Successfully submitted the question.'));
                }
                ,
                error => {
                    dispatch(helpCenterActions.requestHelpFailure({ msg, toAddress, category, includeIntegration, error }));
                    dispatch(alertActions.error(Errors.REQUEST_HELP_FAILURE));
                }
            );
    },
    requestHelpRequest: createAction(ActionNames.REQUEST_HELP_REQUEST),
    requestHelpSuccess: createAction(ActionNames.REQUEST_HELP_SUCCESS),
    requestHelpFailure: createAction(ActionNames.REQUEST_HELP_FAILURE),

     getLocations: (urno) => dispatch => {
        dispatch(helpCenterActions.locationRequest({ urno }));

        helpCenterService.getLocationsForUser(urno)
            .then(
                locations => {
                    dispatch(helpCenterActions.locationSuccess({locations}));
                },
                error => {
                    dispatch(helpCenterActions.locationFailure({error: error}));
                    dispatch(alertActions.error(Errors.LOCATION_LOADING_FAILURE));
                }
            );
    },
    locationRequest: createAction(ActionNames.LOCATION_REQUEST),
    locationSuccess: createAction(ActionNames.LOCATION_SUCCESS),
    locationFailure: createAction(ActionNames.LOCATION_FAILURE),

}
